import { all } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { saga as actorsSaga } from '@savgroup-front-common/core/domains/actors';
import { saga as attachmentsSaga } from '@savgroup-front-common/core/domains/attachments';
import { saga as carriersSaga } from '@savgroup-front-common/core/domains/carriers';
import { saga as claimsSaga } from '@savgroup-front-common/core/domains/claims';
import { saga as fileUploadSaga } from '@savgroup-front-common/core/domains/fileUpload';
import { saga as i18nSaga } from '@savgroup-front-common/core/domains/i18n';
import { saga as sellerConfigurationSaga } from '@savgroup-front-common/core/domains/sellerConfiguration';
import { sellerSaga } from '@savgroup-front-common/core/domains/sellers';
import { sparePartSupplierSaga } from '@savgroup-front-common/core/domains/sparePartSupplier';
import { storeSaga } from '@savgroup-front-common/core/domains/store';
import { technicalInterventionsSaga } from '@savgroup-front-common/core/domains/technicalInterventions';
import { saga as workflowSaga } from '@savgroup-front-common/core/domains/workflow';

import { saga as additionalInformationSaga } from '@/domains/additionalInformation';
import fileSummaryWatchers from '@/domains/workflow/fileSummary/sagas';

import { saga as accessSaga } from './access';
import transportSaga from './business/transport/transportSagas';
import { saga as controlClaimsSaga } from './claims';
import { repairerSaga as controlRepairerSaga } from './controlRepairer';
import { saga as filesSaga } from './files';
import { saga as marketplaceTicketsSaga } from './marketplaceTickets';
import modelsSaga from './models/saga';
import { saga as orderSaga } from './orders';
import { saga as ownerSaga } from './owner';
import { saga as quoteSaga } from './quote';
import editQuote from './quote/editQuote/saga';
import validateQuote from './quote/validateQuote';
import { saga as refundsSaga } from './refunds';
import { repairerSaga } from './repairer';
import { saga as sellersSummarySaga } from './sellersInfo';
import { sparePartRequestSaga } from './sparePartRequests';
import { sparePartsSaga } from './spareParts';
import { stocksSaga } from './stocks';
import { userManagementSaga } from './userManagement';
import { usersSaga } from './users';
import { saga as controlWorkflowSaga } from './workflow';

export default function* rootSaga() {
  try {
    yield all([
      accessSaga(),
      actorsSaga(),
      additionalInformationSaga(),
      attachmentsSaga(),
      carriersSaga(),
      claimsSaga(),
      controlWorkflowSaga(),
      controlRepairerSaga(),
      editQuote(),
      transportSaga(),
      fileUploadSaga(),
      filesSaga(),
      i18nSaga(),
      marketplaceTicketsSaga(),
      modelsSaga(),
      orderSaga(),
      ownerSaga(),
      quoteSaga(),
      sellersSummarySaga(),
      refundsSaga(),
      repairerSaga(),
      sellerConfigurationSaga(),
      sellerSaga(),
      sparePartsSaga(),
      sparePartRequestSaga(),
      sparePartSupplierSaga(),
      stocksSaga(),
      storeSaga(),
      technicalInterventionsSaga(),
      userManagementSaga(),
      usersSaga(),
      validateQuote(),
      workflowSaga(),
      controlClaimsSaga(),

      fileSummaryWatchers(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
